import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import { createPinia, PiniaVuePlugin } from 'pinia';
import VueGtag from 'vue-gtag';
import App from './App.vue';
import router from './router';
import { GameHub, initI18n } from '@/core/utils';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@/core/styles/main.scss';

Vue.use(VueCompositionAPI);
Vue.use(PiniaVuePlugin);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(GameHub);
Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GA_ID },
});

const pinia = createPinia();

Vue.config.productionTip = false;

// Initialize i18n asynchronously before mounting the app
async function startApp() {
  try {
    // Initialize i18n and load translations from API
    const i18n = await initI18n();

    // Mount Vue app with i18n
    new Vue({
      router,
      pinia,
      i18n,
      render: (h) => h(App),
    }).$mount('#app');
  } catch (error) {
    // eslint-disable-next-line
    console.error('Failed to start application:', error);
    // Mount app without i18n as fallback
    new Vue({
      router,
      pinia,
      render: (h) => h(App),
    }).$mount('#app');
  }
}

// Start the application
startApp();
